import Vue from 'vue'
import Router from 'vue-router'
import LandingPage from './pages/LandingPage.vue'
import PartnersPage from './pages/PartnersPage.vue'
import OurStoryPage from './pages/OurStoryPage.vue'

Vue.use(Router)

/**
 * route level code-splitting
 * this generates a separate chunk (about.[hash].js) for this route
 * which is lazy-loaded when the route is visited.
 */
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkExactActiveClass: 'tag is-primary',
  routes: [
    {
      path: '/',
      name: 'home',
      component: LandingPage
    },
    {
      path: '/partners',
      name: 'partners',
      component: PartnersPage
    },
    {
      path: '/story',
      name: 'story',
      component: OurStoryPage
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "demo" */ './pages/AboutPage.vue')
    },
    {
      path: '/demo',
      name: 'demo',
      component: () => import(/* webpackChunkName: "demo" */ './pages/CaptionView.vue')
    },
    {
      path: '/*',
      redirect: '/'
    }
  ]
})

export default router
